type EmailsLocale = typeof import('../en/emails').default

const emails = {
	labels: {
		subjects: 'Asuntos',
	},
	subjects: {
		verify: 'Verifica tu correo - {{brand}}',
		reset: 'Restablece tu contraseña - {{brand}}',
		welcome: 'Te damos la bienvenida a {{brand}}',
		subscriptionActivated: 'Tu suscripción está activa - {{brand}}',
		emailChangeVerification: 'Confirma tu nuevo correo - {{brand}}',
		emailChangeNotice: 'Tu correo fue cambiado - {{brand}}',
	},
	verify: {
		preview: 'Verifica tu correo en {{brand}}',
		greeting: 'Bienvenido a {{brand}}',
		intro: 'Por favor, confirma tu dirección de correo para continuar.',
		button: 'Verificar correo',
		codeLabel: 'Código de verificación',
		codeHelp:
			'Si abriste este correo en otro dispositivo, introduce este código en la pantalla de verificación.',
		footer: 'Si no has creado una cuenta, puedes ignorar este correo.',
	},
	reset: {
		preview: 'Restablece tu contraseña en {{brand}}',
		greeting: 'Solicitud de restablecimiento de contraseña',
		intro:
			'Recibimos una solicitud para restablecer tu contraseña. Haz clic en el botón a continuación para crear una nueva contraseña.',
		button: 'Restablecer contraseña',
		footer: 'Si no solicitaste restablecer tu contraseña, ignora este correo.',
	},
	welcome: {
		preview: '',
		greeting: '',
		intro:
			'Tu cuenta está lista. Empieza tu primer{{mainEntityGenderSuffix}} {{mainEntityLabelLower}} y mantén el ritmo de estudio.',
		button: 'Empezar ahora',
		footer: '¿Necesitas ayuda? Responde este email y te ayudamos.',
	},
	subscriptionActivated: {
		preview: 'Tu suscripción está activa',
		greeting: 'Tu suscripción ya está activa',
		intro:
			'Ya tienes acceso completo. Disfruta del contenido completo y funciones premium.',
		button: 'Gestionar suscripción',
		footer:
			'Puedes gestionar tu facturación desde tu área de usuario cuando quieras.',
	},
	emailChangeVerification: {
		preview: 'Confirma tu nuevo correo en {{brand}}',
		greeting: 'Confirma tu nuevo correo',
		intro:
			'Por favor, confirma esta nueva dirección de correo para completar el cambio.',
		button: 'Confirmar nuevo correo',
		footer: 'Si no solicitaste este cambio, ignora este correo.',
	},
	emailChangeNotice: {
		preview: 'Tu correo fue cambiado en {{brand}}',
		greeting: 'Tu correo ha sido cambiado',
		intro:
			'Te avisamos que la dirección de correo de tu cuenta fue modificada.',
		footer:
			'Si no solicitaste este cambio, contacta soporte de inmediato para proteger tu cuenta.',
	},
} satisfies EmailsLocale

export default emails
